import { useEffect, useRef } from 'react';

/**
 * Iter 64 — auto-save a stage form every `intervalMs` (default 60s) whenever the
 * watched `data` has changed since the last save. `saveFn` should persist silently
 * (no toast / no refetch that disrupts typing). Safe to call in every stage form.
 */
export function useAutosave(saveFn, data, intervalMs = 60000) {
  const lastSaved = useRef(JSON.stringify(data));
  const saveRef = useRef(saveFn);
  const dataRef = useRef(data);
  saveRef.current = saveFn;
  dataRef.current = data;

  useEffect(() => {
    const id = setInterval(() => {
      const cur = JSON.stringify(dataRef.current);
      if (cur !== lastSaved.current) {
        lastSaved.current = cur;
        Promise.resolve(saveRef.current()).catch((e) => console.warn('Autosave failed:', e));
      }
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
}

export default useAutosave;
